import { useQuery } from '@abyss/web/hooks/useQuery';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import EpimSanctionsGlobalSearch from './EpimSanctionsGlobalSearch.gql';

export const useGetEpimSanctionsGlobalSearch = (options) => {
  return useQuery(EpimSanctionsGlobalSearch, {
    ...options,
    url: ApiUrl.graphQl(),
    headers: {
      'Accept-Encoding': 'gzip, deflate, br',
    },
  });
};
